import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f5ca426")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock(_component_el_select, _mergeProps({ ref: "mySelect" }, _ctx.$attrs, {
    modelValue: _ctx.optionValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.optionValue = $event)),
    multiple: false,
    disabled: _ctx.disabled
  }), {
    default: _withId(() => [
      _createVNode(_component_el_option, {
        value: _ctx.optionValue,
        label: _ctx.optionLabel,
        class: "options"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_tree, {
            id: "tree-option",
            ref: "selectTree",
            data: _ctx.options,
            props: _ctx.defaultProps,
            onNodeClick: _ctx.handleNodeClick
          }, null, 8, ["data", "props", "onNodeClick"])
        ]),
        _: 1
      }, 8, ["value", "label"])
    ]),
    _: 1
  }, 16, ["modelValue", "disabled"]))
})